'use client';
 
import {hideDefaultLayout} from '@utils/hideDefaultLayout';

import {usePathname} from 'next/navigation';
import Script from 'next/script';
 
const HelloAldarChatBot = () => {
  const chatbotUrl = process.env.NEXT_PUBLIC_HELLO_ALDAR_URL;
 
  const pathname = usePathname();
  const hideComponent = hideDefaultLayout(pathname);
 
  if (hideComponent) return null;
  return (
    <Script id='chatbot-script' strategy='lazyOnload'>
      {`
        (function() {
          var chatbotIcon = document.createElement('div');
          chatbotIcon.id = 'chatbot-icon';
          chatbotIcon.style.position = 'fixed';
          chatbotIcon.style.bottom = '2%';
          chatbotIcon.style.right = '2%';
          chatbotIcon.style.width = '50px';
          chatbotIcon.style.height = '50px';
          chatbotIcon.style.borderRadius = '50%';
          chatbotIcon.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.3)';
          chatbotIcon.style.cursor = 'pointer';
          chatbotIcon.style.zIndex = '1000';
          chatbotIcon.style.backgroundColor = '#000000';
          chatbotIcon.style.display = 'flex';
          chatbotIcon.className ="vibrate"
 
          var svgContainer = document.createElement('div');
          svgContainer.style.width = '24px';
          svgContainer.style.height = '24px';
 
          const svgContentOne = \`
            <svg
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="animate-hide-show"
            >
                <circle cx="25" cy="25" r="25" fill="black" />
                <path
                d="M40.2367 33.2692C40.9209 32.8781 41.4104 32.1517 41.4104 30.9295C41.4104 28.7924 39.953 28.1638 38.49 28.1638H35.3082V36H37.5722V33.6882H38.1006L39.5135 36H42L40.2367 33.2692ZM38.4455 31.7467H37.5722V30.266H38.4455C38.8849 30.266 39.1408 30.5733 39.1408 31.0063C39.1408 31.4394 38.8849 31.7467 38.4455 31.7467ZM23.838 28.1568H20.8787V35.993H23.838C26.2967 35.993 27.3981 34.3657 27.3981 32.0749C27.3981 29.7841 26.2967 28.1568 23.838 28.1568ZM23.7824 33.8279H23.1483V30.3359H23.7824C24.589 30.3359 25.0785 30.8038 25.0785 32.0819C25.0785 33.36 24.589 33.8279 23.7824 33.8279ZM17.3131 28.1638H15.0491V36H20.2446V33.7371H17.3075V28.1638H17.3131ZM9.56993 28.1638L7 36H9.2918L9.59774 34.9594H11.973L12.2678 36H14.5596L12.0008 28.1638H9.56993ZM10.1206 33.0876L10.599 31.4184C10.6658 31.1251 10.7381 30.8178 10.7826 30.4127C10.8271 30.8178 10.8994 31.1251 10.9773 31.4184L11.4557 33.0876H10.1151H10.1206ZM29.829 28.1638L27.2591 36H29.5509L29.8568 34.9594H32.232L32.5269 36H34.8187L32.2599 28.1638H29.829ZM30.3797 33.0876L30.8581 31.4184C30.9248 31.1251 30.9971 30.8178 31.0416 30.4127C31.0861 30.8178 31.1585 31.1251 31.2363 31.4184L31.7147 33.0876H30.3741H30.3797ZM32.8717 22.4857C32.7605 23.254 32.7994 23.9314 32.983 24.5181C33.1666 25.1048 33.4725 25.5517 33.912 25.873C34.3514 26.1943 34.8798 26.3549 35.5029 26.3549C36.3373 26.3549 37.1383 26.1105 37.8892 25.6286C38.6457 25.1467 39.2743 24.4762 39.7916 23.6241C40.3034 22.7721 40.6372 21.8152 40.7818 20.7606C40.8875 19.9924 40.8485 19.3149 40.665 18.7283C40.4814 18.1486 40.1643 17.6946 39.7249 17.3663C39.2854 17.0451 38.7514 16.8775 38.1284 16.8775C37.2885 16.8775 36.4986 17.1219 35.7476 17.6108C34.9967 18.0997 34.3681 18.7771 33.8563 19.6362C33.3446 20.4952 33.0219 21.4451 32.8717 22.4927V22.4857ZM35.1858 22.2413C35.2525 21.7454 35.3972 21.2705 35.6197 20.8235C35.8366 20.3695 36.1092 20.0063 36.4263 19.727C36.7489 19.4476 37.0938 19.3079 37.4609 19.3079C37.828 19.3079 38.0895 19.4546 38.2786 19.7549C38.4677 20.0552 38.5289 20.4743 38.4511 21.026C38.3843 21.5079 38.2397 21.9759 38.0172 22.4229C37.7947 22.8698 37.5221 23.233 37.1883 23.5124C36.8601 23.7917 36.5153 23.9314 36.1537 23.9314C35.7921 23.9314 35.5307 23.7848 35.3471 23.4914C35.1635 23.1981 35.1079 22.786 35.1858 22.2483V22.2413ZM30.6968 26.2152L34.1066 14H31.8927L28.4828 26.2152H30.6968ZM26.9031 26.2152L30.3129 14H28.099L24.6891 26.2152H26.9031ZM11.7783 21.1867V21.2216C11.9452 20.607 12.201 20.1251 12.5459 19.7829C12.8853 19.4406 13.2746 19.273 13.703 19.273C14.0645 19.273 14.3315 19.3987 14.4984 19.6502C14.6653 19.9016 14.7154 20.2578 14.6542 20.7257C14.6319 20.8724 14.5985 21.033 14.5485 21.2216L13.1467 26.2222H15.3495L16.857 20.8375C16.9571 20.4883 17.0294 20.153 17.0739 19.8457C17.2018 18.9238 17.1017 18.2044 16.7624 17.6806C16.4231 17.1638 15.9002 16.9054 15.1937 16.9054C14.7098 16.9054 14.2425 17.0241 13.7975 17.2616C13.3525 17.499 12.9576 17.8203 12.6127 18.2254L13.7864 14H11.5725L8.16259 26.2152H10.3765L11.7839 21.1797L11.7783 21.1867ZM19.9609 26.3479C20.8342 26.3479 21.6575 26.0476 22.4418 25.454C23.2262 24.8603 23.838 24.0921 24.2775 23.1562H21.9189C21.5407 23.7498 21.079 24.0502 20.5227 24.0502C20.1778 24.0502 19.922 23.9244 19.7495 23.673C19.5771 23.4216 19.527 23.0514 19.5938 22.5695C19.616 22.4298 19.6327 22.3251 19.6494 22.2552H24.6613C24.7726 21.9689 24.8616 21.6965 24.9283 21.4451C25.0118 21.1587 25.0785 20.8305 25.1286 20.4743C25.2843 19.3638 25.1286 18.4838 24.678 17.8413C24.2219 17.1987 23.5265 16.8775 22.592 16.8775C21.8744 16.8775 21.1902 17.073 20.5283 17.4571C19.8719 17.8413 19.2878 18.393 18.7816 19.1054C18.2754 19.8178 17.8916 20.6559 17.6246 21.6127C17.5189 21.9759 17.4466 22.3251 17.3965 22.6673C17.2352 23.7987 17.391 24.6997 17.8527 25.3562C18.3144 26.0127 19.0153 26.3479 19.9442 26.3479H19.9609ZM20.8676 19.5733C21.1958 19.28 21.5518 19.1333 21.9301 19.1333C22.2861 19.1333 22.5531 19.2521 22.7367 19.4895C22.9202 19.727 22.9814 20.0622 22.9202 20.5022C22.9147 20.5581 22.8868 20.6629 22.8535 20.8165H20.0722C20.278 20.2787 20.545 19.8597 20.8732 19.5733H20.8676Z"
                fill="white"
                />
            </svg>
          \`;
          const svgContent = \`
            <svg
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <circle cx="25" cy="25" r="25" fill="black" />
                <path
                    d="M35 24.567c0 5.283-4.478 9.567-10 9.567a10.41 10.41 0 0 1-1.935-.179c-.459-.086-.689-.129-.849-.105s-.387.145-.841.387a6.5 6.5 0 0 1-4.224.657c.548-.674.922-1.482 1.087-2.348.1-.53-.148-1.045-.519-1.422C16.033 29.412 15 27.105 15 24.567 15 19.284 19.478 15 25 15s10 4.284 10 9.567z"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <circle
                    class="dot dot-1"
                    cx="21"
                    cy="25"
                    r="1"
                    fill="white"
                />
                <circle
                    class="dot dot-2"
                    cx="25"
                    cy="25"
                    r="1"
                    fill="white"
                />
                <circle
                    class="dot dot-3"
                    cx="29"
                    cy="25"
                    r="1"
                    fill="#A39E97"
                />
                </svg>
          \`;
          let currentIndex = 0;
          let messages=[svgContent,svgContentOne]
          svgContainer.innerHTML = svgContentOne
          chatbotIcon.appendChild(svgContainer);
          function updateContent() {
          svgContainer.innerHTML = messages[currentIndex];
          chatbotIcon.appendChild(svgContainer);
          currentIndex = (currentIndex + 1) % messages.length;
          }
          setInterval(updateContent, 4000);
 
          var chatbotContainer = document.createElement('div');
          chatbotContainer.id = 'chatbot-container';
          chatbotContainer.style.position = 'fixed';
          chatbotContainer.style.bottom = '11%';
          chatbotContainer.style.right = '2%';
          chatbotContainer.style.height = '550px';
          chatbotContainer.style.borderRadius = '10px';
          chatbotContainer.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.3)';
          chatbotContainer.style.zIndex = '1000';
          chatbotContainer.style.display = 'none';
          chatbotContainer.style.flexDirection = 'column';
          chatbotContainer.style.overflow = 'hidden';
          chatbotContainer.style.backgroundColor = '#FFFFFF';

          var chatbotIframe = document.createElement('iframe');
          chatbotIframe.id = 'chatbot-iframe';
          chatbotIframe.src = '${chatbotUrl}';
          chatbotIframe.style.width = '100%';
          chatbotIframe.style.height = '100%';
          chatbotIframe.style.border = 'none';
          chatbotIframe.style.borderRadius = '10px';
          chatbotIframe.allow = 'clipboard-write; clipboard-read; camera; microphone; geolocation';
          chatbotIframe.sandbox = "allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation";
          chatbotContainer.appendChild(chatbotIframe);
 
          document.body.appendChild(chatbotIcon);
          document.body.appendChild(chatbotContainer);
 
          chatbotIcon.onclick = function() {
            if (chatbotContainer.style.display === 'none') {
              chatbotContainer.style.display = 'flex';
            } else {
              chatbotContainer.style.display = 'none';
            }
 
             const chatbotIframe = document.getElementById('chatbot-iframe');
                if (chatbotIframe && chatbotIframe.contentWindow) {
                    chatbotIframe.contentWindow.postMessage({name: 'chatbot_click', product: 'Aldar Properties'}, '*');
                }
                   
          };
 
           const style = document.createElement('style');
          style.innerHTML = \`
            @media (max-width: 599px) { #chatbot-container { width: 90%; } }
            @media (min-width: 600px) and (max-width: 899px) { #chatbot-container { width: 51%; } }
            @media (min-width: 900px) and (max-width: 1199px) { #chatbot-container { width: 39%; } }
            @media (min-width: 1200px) { #chatbot-container { width: 27%; } }
            @keyframes hideShow {
          0%,
          100% {
            opacity: 0; /* Hidden */
          }
          50% {
            opacity: 1; /* Visible */
          }
        }
 
        /* Tailwind utility for the animation */
        .animate-hide-show {
          animation: hideShow 2s infinite;
        }
        .dot {
          animation: bounce 1.5s infinite ease-in-out;
        }
 
        .dot-1 {
          animation-delay: 0s;
        }
        .dot-2 {
          animation-delay: 0.5s;
        }
        .dot-3 {
          animation-delay: 1s;
        }
 
        @keyframes bounce {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-3px); /* Move upward */
          }
        }
        .vibrate {
          animation: vibrate-animation 1s ease-in-out infinite; /* Reduced speed by increasing duration */
        }
 
        @keyframes vibrate-animation {
          0% {
            transform: translate(0, 0); /* Original position */
          }
          20% {
            transform: translate(2px, 2px); /* Slight movement */
          }
          40% {
            transform: translate(0, 0); /* Slight opposite movement */
          }
          60% {
            transform: translate(0, 0); /* Slight movement */
          }
          80% {
            transform: translate(0, 0); /* Slight opposite movement */
          }
          100% {
            transform: translate(0, 0); /* Back to the original position */
          }
        }
          \`;
          document.head.appendChild(style);
        }
          )();
      `}
    </Script>
  );
};
 
export default HelloAldarChatBot;